import CheckoutComponent from './CheckoutComponent';

export default class CheckoutBasket {
    static readonly basketContainer = '#checkout';
    static readonly plus: string =
        CheckoutBasket.basketContainer + ' .basket-item-amount-btn-plus';
    static readonly minus: string =
        CheckoutBasket.basketContainer + ' .basket-item-amount-btn-minus';
    static readonly scu: string =
        CheckoutBasket.basketContainer + ' .basket-item-scu-item';
    static readonly delBtn: string =
        CheckoutBasket.basketContainer + ' .basket-item-delete-btn';
    static readonly wishBtn: string =
        CheckoutBasket.basketContainer + ' .basket-item-wish-btn';
    static readonly quantityField: string =
        CheckoutBasket.basketContainer + '.basket-item-amount-filed';
    static readonly menuBtn: string =
        CheckoutBasket.basketContainer + ' .basket-item-menu-btn';
    static readonly url: string = '/?ajaxAction=';
    static readonly upProductionQuantity: string =
        CheckoutBasket.url + 'basketUpProductQuantity';
    static readonly downProductionQuantity: string =
        CheckoutBasket.url + 'basketDownProductQuantity';
    static readonly toggleOffer: string =
        CheckoutBasket.url + 'basketToggleOffer';
    static readonly deleteProduct: string =
        CheckoutBasket.url + 'delBasketItem';
    static readonly addToWishList: string =
        CheckoutBasket.url + 'addToWishList';
    static readonly setQuantity: string =
        CheckoutBasket.url + 'setBasketQuantity';
    static readonly clearBasketUrl: string = '/?ajaxAction=clearBasket';
    static readonly arComponentsReload: string[] = [
        'basket',
        'delivery',
        'total',
    ];
    private BX: any;

    static readonly openProducts: string =
        CheckoutBasket.basketContainer + ' .basket-arrow-open-products';

    constructor(BX: any) {
        this.BX = BX;
    }

    init() {
        this.bindEvents();
        this.fixBasketTotalBlock();
    }

    bindEvents() {
        this.onClick(CheckoutBasket.plus);
        this.onClick(CheckoutBasket.minus);
        this.onClick(CheckoutBasket.scu);
        this.onClick(CheckoutBasket.delBtn);
        this.onClick(CheckoutBasket.wishBtn);
        this.onClick(CheckoutBasket.menuBtn);
        this.onClick(CheckoutBasket.openProducts);
        let self = this;
        $(document).on('change', '.basket-item-amount-filed', function (e) {
            self.setQuantity(e);
        });
        $('body').on('click', function (e) {
            self.closeAllBasketMenu(e);
        });
        $(document).on('click', '.clear-basket-confirm-btn', function () {
            self.openConfirmClearBasketDialog();
        });
        $(document).on('click', '.clear-basket-btn', function () {
            self.clearBasket();
        });
        $(document).on('scroll', function () {
            self.fixBasketTotalBlock();
        });
        $(window).on('resize', function () {
            self.fixBasketTotalBlock();
        });
        $(document).on('click', '.cancel-remote-store-btn', function (e) {
            self.cancelRemoteStore(e);
        });
        $(document).on('click', '.apply-remote-store-btn', function (e) {
            self.applyRemoteStore(e);
        });
    }

    cancelRemoteStore(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        e.preventDefault();
        let $checkout = $('#checkout');
        if ($checkout.hasClass('process')) {
            return false;
        }
        $checkout.addClass('process');
        $.post(
            '/',
            {
                ajaxAction: 'cancelRemoteStore',
                basketItemId: $(e.target).data('id'),
            },
            function (data) {
                CheckoutComponent.reloadComponents(
                    CheckoutBasket.arComponentsReload
                );
            },
            'json'
        );

        return false;
    }

    applyRemoteStore(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        e.preventDefault();
        let $checkout = $('#checkout');
        if ($checkout.hasClass('process')) {
            return false;
        }
        $checkout.addClass('process');
        $.post(
            '/',
            {
                ajaxAction: 'applyRemoteStore',
                basketItemId: $(e.target).data('id'),
            },
            function (data) {
                CheckoutComponent.reloadComponents(
                    CheckoutBasket.arComponentsReload
                );
            },
            'json'
        );

        return false;
    }

    fixBasketTotalBlock() {
        let $checkout = $('#checkout');
        if ($(window).width() > 767) {
            $checkout.removeClass('fixed-total');
            return;
        }
        if (
            $(document).scrollTop() + $(window).height() >=
            $checkout.offset().top + $checkout.innerHeight()
        ) {
            $checkout.removeClass('fixed-total');
            return;
        }
        $checkout.addClass('fixed-total');
    }

    onClick(el: string): any {
        let self = this;
        let f = function (e: JQuery.ClickEvent<Document, undefined, any, any>) {
            switch (el) {
                case CheckoutBasket.plus: {
                    self.upProductQuantity(e);
                    break;
                }
                case CheckoutBasket.minus: {
                    self.downProductQuantity(e);
                    break;
                }
                case CheckoutBasket.scu: {
                    self.toggleOffer(e);
                    break;
                }
                case CheckoutBasket.delBtn: {
                    self.deleteProduct(e);
                    break;
                }
                case CheckoutBasket.menuBtn: {
                    self.toggleBasketMenu(e);
                    break;
                }
                case CheckoutBasket.wishBtn: {
                    self.addToWishList(e);
                    break;
                }
                case CheckoutBasket.openProducts: {
                    self.openProducts(e);
                    break;
                }
            }
        };
        CheckoutComponent.onClick(el, f);
    }

    addToWishList(e: JQuery.ClickEvent<Document, undefined, any, any>) {
        this.post(CheckoutBasket.addToWishList, {
            basketItemId: $(e.target).data('id'),
        });
    }

    toggleBasketMenu(
        e: JQuery.ClickEvent<Document, undefined, any, any>
    ): void {
        $(e.target)
            .closest('.grid-item')
            .find('.basket-item-menu')
            .toggleClass('hidden');
    }

    closeAllBasketMenu(
        e: JQuery.ClickEvent<Document, undefined, any, any>
    ): void {
        if (!$(e.target).hasClass('basket-item-menu-btn')) {
            $('.basket-item-menu').addClass('hidden');
        }
    }

    openConfirmClearBasketDialog(): void {
        $('#clear-basket-confirm-modal').appendTo('body').modal();
    }

    setQuantity(e: JQuery.ChangeEvent<Document, undefined, any, any>): void {
        let $input = $(e.target)
            .closest('.basket-item-block-amount')
            .find('.basket-item-amount-filed');
        if ($input.prop('disabled')) {
            return;
        }
        $input.prop('disabled', true);
        this.post(CheckoutBasket.setQuantity, {
            basketItemId: $(e.target).data('item-id'),
            quantity: $(e.target).val(),
        });
    }

    clearBasket() {
        this.post(CheckoutBasket.clearBasketUrl, {
            action: 'clearBasket',
        });
    }

    deleteProduct(e: JQuery.ClickEvent<Document, undefined, any, any>): void {
        this.post(CheckoutBasket.deleteProduct, {
            basketItemId: $(e.target).data('id'),
        });
    }

    upProductQuantity(
        e: JQuery.ClickEvent<Document, undefined, any, any>
    ): void {
        let $input = $(e.target)
            .closest('.basket-item-block-amount')
            .find('.basket-item-amount-filed');
        if ($input.prop('disabled')) {
            window.BX.UI.Notification.Center.notify({
                content: 'Превышено допустимое количество товара для покупки',
                autoHideDelay: 3000
            });
            return;
        }
        $input.prop('disabled', true);
        this.post(CheckoutBasket.upProductionQuantity, {
            productId: $(e.target).data('product-id'),
        });
    }

    downProductQuantity(
        e: JQuery.ClickEvent<Document, undefined, any, any>
    ): void {
        let $input = $(e.target)
            .closest('.basket-item-block-amount')
            .find('.basket-item-amount-filed');
        if ($input.prop('disabled')) {
            return;
        }
        $input.prop('disabled', true);
        if ($input.val() == 1) {
            this.deleteProduct(e);
        } else {
            this.post(CheckoutBasket.downProductionQuantity, {
                productId: $(e.target).data('product-id'),
            });
        }
    }

    toggleOffer(e: JQuery.ClickEvent<Document, undefined, any, any>): void {
        let $offersList = $(e.target).closest('.basket-item-scu-list');
        if ($('#checkout').hasClass('process')) {
            return;
        }
        let $currentOffer = $offersList.find('.basket-item-scu-item.selected');
        let $newOffer = $(e.target).closest('.basket-item-scu-item');
        $.post(
            CheckoutBasket.toggleOffer,
            {
                currentOfferId: $currentOffer.data('offer-id'),
                newOfferId: $newOffer.data('offer-id'),
            },
            function (data) {
                CheckoutComponent.reloadComponents(
                    CheckoutBasket.arComponentsReload
                );
            },
            'json'
        );
    }

    reloadTotalAndBasket() {
        return function (data: any) {
            if (data.status == 1) {
                CheckoutComponent.reloadComponents(
                    CheckoutBasket.arComponentsReload
                );
            }
        };
    }

    post(href: string, data: any) {
        data.sessid = this.BX.bitrix_sessid();
        CheckoutComponent.post(href, data, this.reloadTotalAndBasket());
    }

    /**
     * Раскрытие блока товаров
     * @param e
     */
    openProducts(e: JQuery.ClickEvent<Document, undefined, any, any>)
    {
        let gridMainBlock = $(e.target).closest('.basket-group').find('.basket-grid-main');
        let gridShortBlock = $(e.target).closest('.basket-grid-short').find('.basket-grid-short-items');
        gridMainBlock.slideToggle('slow');
        gridShortBlock.slideToggle('slow');
        $(e.target).toggleClass('close-block');
    }
}
